import i18n from "../i18n";
import { TenantFeatureSettingWorkFlowType } from "./tenant-workflows-types";

export const cefTenantFeatureSettingsNames = {
    bankAccount: "BankAccount",
    cashDiscCode: "CashDiscCode",
    fixedAssetPostingProfiles: "FixedAssetPostingProfiles",
    fixedAssets: "FixedAssets",
    mainDimension: "MainDimension",
    miscCharge: "MiscCharge",
    paymentInformation: "PaymentInformation",
    paymentTerm: "PaymentTerm",
    productReceipt: "ProductReceipt",
    projectActivities: "ProjectActivities",
    projectDefaultLineProperties: "ProjectDefaultLineProperties",
    projectLineProperties: "ProjectLineProperties",
    purchaseAgreementHeaders: "PurchaseAgreementHeaders",
    purchaseAgreementLines: "PurchaseAgreementLines",
    purchaseOrder: "PurchaseOrder",
    salesTax: "SalesTax",
    vendor: "Vendor",
};

export const tenantFeatureSettingDefinitions = {
    [TenantFeatureSettingWorkFlowType.BankAccountChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.bankAccount,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.bankAccountChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.CaptureMailboxesCreation]: {
        urlParameterValue: "CaptureMailboxesCreation",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.captureMailboxesCreation"
        ),
    },
    [TenantFeatureSettingWorkFlowType.CashDiscCodeChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.cashDiscCode,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.cashDiscCodeChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.CodingPrediction]: {
        urlParameterValue: "CodingPrediction",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.mlCodingPrediction"
        ),
    },
    [TenantFeatureSettingWorkFlowType.D365RoleDooapRequiredToAccessDooap]: {
        urlParameterValue: "D365RoleDooapRequiredToAccessDooap",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.d365RoleDooapRequiredToAccessDooap"
        ),
    },
    [TenantFeatureSettingWorkFlowType.DatabaseAlertRuleCreation]: {
        urlParameterValue: "DatabaseAlertRuleCreation",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.databaseAlertRuleCreation"
        ),
    },
    [TenantFeatureSettingWorkFlowType.DocumentsTransfer]: {
        urlParameterValue: "DocumentsTransfer",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.documentsTransfer"
        ),
    },
    [TenantFeatureSettingWorkFlowType.EnableSftp]: {
        urlParameterValue: "EnableSFTP",
        displayName: i18n.t("tenantFeatureSetting.workFlowName.enableSftp"),
    },
    [TenantFeatureSettingWorkFlowType.FixedAssetPostingProfilesChangeEntityFramework]:
        {
            urlParameterValue:
                cefTenantFeatureSettingsNames.fixedAssetPostingProfiles,
            displayName: i18n.t(
                "tenantFeatureSetting.workFlowName.fixedAssetPostingProfilesChangeEntityFramework"
            ),
        },
    [TenantFeatureSettingWorkFlowType.FixedAssetsChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.fixedAssets,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.fixedAssetsChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.KeyVaultAppRegistrationSecretRotation]: {
        urlParameterValue: "KeyVaultAppRegistrationSecretRotation",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.keyVaultAppRegistrationSecretRotation"
        ),
    },
    [TenantFeatureSettingWorkFlowType.MainDimensionChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.mainDimension,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.mainDimensionValuesChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.MiscChargeChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.miscCharge,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.miscChargeChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.PaymentInformationChangeEntityFramework]:
        {
            urlParameterValue: cefTenantFeatureSettingsNames.paymentInformation,
            displayName: i18n.t(
                "tenantFeatureSetting.workFlowName.paymentInformationChangeEntityFramework"
            ),
        },
    [TenantFeatureSettingWorkFlowType.PaymentTermChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.paymentTerm,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.paymentTermChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.PowerBiWorkspaceDeployment]: {
        urlParameterValue: "PowerBiWorkspaceDeployment",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.powerBiWorkspaceDeployment"
        ),
    },
    [TenantFeatureSettingWorkFlowType.ProductReceiptChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.productReceipt,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.productReceiptChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.ProjectActivitiesChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.projectActivities,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.projectActivitiesChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.ProjectDefaultLinePropertiesChangeEntityFramework]:
        {
            urlParameterValue:
                cefTenantFeatureSettingsNames.projectDefaultLineProperties,
            displayName: i18n.t(
                "tenantFeatureSetting.workFlowName.projectDefaultLinePropertiesChangeEntityFramework"
            ),
        },
    [TenantFeatureSettingWorkFlowType.ProjectLinePropertiesChangeEntityFramework]:
        {
            urlParameterValue:
                cefTenantFeatureSettingsNames.projectLineProperties,
            displayName: i18n.t(
                "tenantFeatureSetting.workFlowName.projectLinePropertiesChangeEntityFramework"
            ),
        },
    [TenantFeatureSettingWorkFlowType.PurchaseAgreementHeadersChangeEntityFramework]:
        {
            urlParameterValue:
                cefTenantFeatureSettingsNames.purchaseAgreementHeaders,
            displayName: i18n.t(
                "tenantFeatureSetting.workFlowName.purchaseAgreementHeadersChangeEntityFramework"
            ),
        },
    [TenantFeatureSettingWorkFlowType.PurchaseAgreementLinesChangeEntityFramework]:
        {
            urlParameterValue:
                cefTenantFeatureSettingsNames.purchaseAgreementLines,
            displayName: i18n.t(
                "tenantFeatureSetting.workFlowName.purchaseAgreementLinesChangeEntityFramework"
            ),
        },
    [TenantFeatureSettingWorkFlowType.PurchaseOrderChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.purchaseOrder,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.purchaseOrderChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.SalesTaxChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.salesTax,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.salesTaxChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.SalesTaxPrediction]: {
        urlParameterValue: "SalesTaxPrediction",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.mlSalesTaxPrediction"
        ),
    },
    [TenantFeatureSettingWorkFlowType.SearchServiceSelection]: {
        urlParameterValue: "SearchServiceSelection",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.searchServiceSelection"
        ),
    },
    [TenantFeatureSettingWorkFlowType.SimilarityVendorRecognition]: {
        urlParameterValue: "SimilarityVendorRecognition",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.similarityVendorRecognition"
        ),
    },
    [TenantFeatureSettingWorkFlowType.VendorChangeEntityFramework]: {
        urlParameterValue: cefTenantFeatureSettingsNames.vendor,
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.vendorChangeEntityFramework"
        ),
    },
    [TenantFeatureSettingWorkFlowType.WorkflowPrediction]: {
        urlParameterValue: "WorkflowPrediction",
        displayName: i18n.t(
            "tenantFeatureSetting.workFlowName.mlWorkflowPrediction"
        ),
    },
};

export const axImportNameToWorkflowTypeMapping: {
    [key: string]: TenantFeatureSettingWorkFlowType;
} = {
    [cefTenantFeatureSettingsNames.bankAccount]:
        TenantFeatureSettingWorkFlowType.BankAccountChangeEntityFramework,
    [cefTenantFeatureSettingsNames.cashDiscCode]:
        TenantFeatureSettingWorkFlowType.CashDiscCodeChangeEntityFramework,
    [cefTenantFeatureSettingsNames.fixedAssetPostingProfiles]:
        TenantFeatureSettingWorkFlowType.FixedAssetPostingProfilesChangeEntityFramework,
    [cefTenantFeatureSettingsNames.fixedAssets]:
        TenantFeatureSettingWorkFlowType.FixedAssetsChangeEntityFramework,
    [cefTenantFeatureSettingsNames.mainDimension]:
        TenantFeatureSettingWorkFlowType.MainDimensionChangeEntityFramework,
    [cefTenantFeatureSettingsNames.miscCharge]:
        TenantFeatureSettingWorkFlowType.MiscChargeChangeEntityFramework,
    [cefTenantFeatureSettingsNames.paymentInformation]:
        TenantFeatureSettingWorkFlowType.PaymentInformationChangeEntityFramework,
    [cefTenantFeatureSettingsNames.paymentTerm]:
        TenantFeatureSettingWorkFlowType.PaymentTermChangeEntityFramework,
    [cefTenantFeatureSettingsNames.productReceipt]:
        TenantFeatureSettingWorkFlowType.ProductReceiptChangeEntityFramework,
    [cefTenantFeatureSettingsNames.projectActivities]:
        TenantFeatureSettingWorkFlowType.ProjectActivitiesChangeEntityFramework,
    [cefTenantFeatureSettingsNames.projectDefaultLineProperties]:
        TenantFeatureSettingWorkFlowType.ProjectDefaultLinePropertiesChangeEntityFramework,
    [cefTenantFeatureSettingsNames.projectLineProperties]:
        TenantFeatureSettingWorkFlowType.ProjectLinePropertiesChangeEntityFramework,
    [cefTenantFeatureSettingsNames.purchaseAgreementHeaders]:
        TenantFeatureSettingWorkFlowType.PurchaseAgreementHeadersChangeEntityFramework,
    [cefTenantFeatureSettingsNames.purchaseAgreementLines]:
        TenantFeatureSettingWorkFlowType.PurchaseAgreementLinesChangeEntityFramework,
    [cefTenantFeatureSettingsNames.purchaseOrder]:
        TenantFeatureSettingWorkFlowType.PurchaseOrderChangeEntityFramework,
    [cefTenantFeatureSettingsNames.salesTax]:
        TenantFeatureSettingWorkFlowType.SalesTaxChangeEntityFramework,
    [cefTenantFeatureSettingsNames.vendor]:
        TenantFeatureSettingWorkFlowType.VendorChangeEntityFramework,
};
